module.exports = __webpack_public_path__ + "img/Unaudited.dfec6ebb.png";